<template>
  <div class="lightUgTable">
    <div
      ref="lightUgTableHead"
      :style="{ top: stickyTop }"
      class="lightUgTable__head"
    >
      <slot name="header"></slot>
    </div>
    <div class="lightUgTable__body">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class LightUgTable extends Vue {
  @Prop({ type: String, default: "0" })
  stickyTop!: string;
}
</script>

<style lang="scss" scoped>
.lightUgTable {
  font-size: 12px;
}
.lightUgTable__head {
  position: sticky;
  width: 100%;
}

@media print {
  .lightUgTable__head {
    position: static;
  }
}
</style>
